import { apiClient } from '@isocel/front-common';

import { LoadingSession, LoadingSessionStatus, PackagingFlow } from './types';

// Fetch function for Loading Session by StoreId And Status
export const fetchLoadingSessions = async (
    storeId: string | undefined,
    status: LoadingSessionStatus = LoadingSessionStatus.New,
    trailerNumber?: string
): Promise<LoadingSession[]> => {
    if (!storeId) {
        throw new Error('Store ID is required');
    }

    const { data } = await apiClient().get(`/loadingSessions/${storeId}/${status}`, {
        params: {
            trailerNumber,
        },
    });

    return data;
};

export const fetchLoadingSessionsPackage = async (loadingSessionId: string | undefined): Promise<PackagingFlow> => {
    if (!loadingSessionId) {
        throw new Error('loadingSessionI ID is required');
    }

    const { data } = await apiClient().get(`/packagingFlow/byLoadingSession/${loadingSessionId}`);

    return data;
};
